import { Vue, Options } from 'vue-class-component';
import {
  DateAndTimeTrigger,
  SceneActionListItemDTO,
  SceneActionsListsDTO,
  SceneObjectType,
  TimeCondition,
} from '@/../client-generator/generated-clients/plants';
import DialogAddAction from '../DialogAddAction/DialogAddAction.vue';
import { SceneWizardStepEnum } from '../SceneWizardStep';
import DialogAddTriggerAndCondition from '../DialogAddTriggerAndCondition/DialogAddTriggerAndCondition.vue';

@Options({
  name: 'ScenePanelTime',
  props: {
    name: {
      required: true,
      type: String,
    },
    stepToAdd: {
      required: true,
      type: Number,
    },
  },
  emits: ['add-action', 'add-trigger', 'add-condition'],
  components: {
    DialogAddAction,
    DialogAddTriggerAndCondition,
  },
})
export default class ScenePanelTime extends Vue {
  name!: string;
  SceneObjectType = SceneObjectType;
  stepToAdd!: SceneWizardStepEnum;
  isVisibleDialogAddObject = false;
  isVisibleDialogTrigger = false;
  tempToAdd:
    | SceneActionsListsDTO
    | DateAndTimeTrigger
    | TimeCondition
    | null = null;

  openShowDialogAction() {
    if (this.stepToAdd === SceneWizardStepEnum.STEP_ACTION) {
      this.tempToAdd = new SceneActionListItemDTO({
        id: -1,
        name: this.name,
        waitTime: '',
        sceneObjectType: SceneObjectType.DateTime,
      });
      this.isVisibleDialogAddObject = true;
    } else if (this.stepToAdd === SceneWizardStepEnum.STEP_TRIGGER) {
      this.tempToAdd = new DateAndTimeTrigger({
        id: -1,
        time: '',
        weekDays: [],
        isSuspended: false,
      });
      this.isVisibleDialogTrigger = true;
    } else if (this.stepToAdd === SceneWizardStepEnum.STEP_CONDITION) {
      this.tempToAdd = new TimeCondition({
        id: -1,
        startTime: '',
        endTime: '',
        weekDays: [],
        isSuspended: false,
      });
      this.isVisibleDialogTrigger = true;
    }
  }
  handleDoAddObject() {
    this.$emit('add-action', this.tempToAdd);
  }
  handleDoAddTrigger() {
    if (this.stepToAdd === SceneWizardStepEnum.STEP_TRIGGER) {
      this.$emit(
        'add-trigger',
        this.tempToAdd,
        this.name,
        SceneObjectType.DateTime
      );
    } else {
      this.$emit(
        'add-condition',
        this.tempToAdd,
        this.name,
        SceneObjectType.DateTime
      );
    }
  }
}
